module.exports = __webpack_public_path__ + "img/OPET.63987f34.svg";